export const STATUS_STYLES = {
  wasting: { label: "Wasting", cls: "bg-[#FEF2F2] text-[#B91C1C] border-[#FECACA]", bar: "#DC2626", icon: "up" },
  on_track: { label: "On Track", cls: "bg-[#FFFBEB] text-[#92400E] border-[#FDE68A]", bar: "#D97706", icon: "flat" },
  efficient: { label: "Efficient", cls: "bg-[#F0FDF4] text-[#156F5B] border-[#BBF7D0]", bar: "#156F5B", icon: "down" },
  unknown: { label: "No Data", cls: "bg-[#F9FAFB] text-[#6B7280] border-[#E5E7EB]", bar: "#9CA3AF", icon: "flat" },
};

export function statusOf(status) {
  return STATUS_STYLES[status] || STATUS_STYLES.unknown;
}
